import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

import { Global } from '../../../../app.global';
import { Constants } from '../../helper/constants';
import { CustomReportsTextCopy } from '../../helper/textcopy/custom-reports.text';
import { CustomReportModel, CustomReportRequestModel } from '../../viewmodels/customReport.model';
import { ReportsService } from '../../services/reports.service';
import { AdminService } from '../../../../layouts/services/admin.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'custom-reports',
  templateUrl: './custom-reports.component.html',
  styleUrls: ['./custom-reports.component.scss'],
})
export class CustomReportsComponent implements OnInit {
 // Add ViewChild to capture reference to the results section
  @ViewChild('resultsSection') resultsSection!: ElementRef;
  constants = Constants;
  reportsCopy = CustomReportsTextCopy;
  customReport: CustomReportModel = new CustomReportModel();

  teams = [];
  users = [];
  contraventions = [];
  stages = [];
  bespoke = [];
  pcnTypes = [];
  decisions = [];
  pcnPrefixes = [];
  ufus = [];
  overrides = [];
  reasons = [];
  letter = {
    content: '',
    documents: [],
    reasons: [],
  };

  reportsResult = [];
  maxReportRows = 5000;
  reportsSort = '';
  loadingState = false;
  searchingState = false;
  totalFineAmount = 0;

  filterOrder = {
    isFullnameAsc: true,
    isDateAsc: true,
    isPcnAsc: true,
    isStageAsc: true,
    isDecisionAsc: true,
    isChargeAsc: true,
    isProgressionAsc: true,
    isBespokeAsc: true,
    isOverrideAsc: true,
    isUfuAsc: true,
  };

  constructor(
    private modalService: NgbModal,
    public global: Global,
    private adminService: AdminService,
    private reportsService: ReportsService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.setTeams();
    this.setContraventions();
    this.setStages();
    this.setBespoke();
    this.setPcnTypes();
    this.setDecisions();
    this.setPcnPrefixes();
    this.setUfus();
    this.setOverrides();
    this.setReasons();
  }

  setTeams() {
    this.teams = [];
    this.reportsService.getAllTeamLeaders().subscribe((result) => {
      if (result) {
        result.forEach((team) => {
          this.teams.push({
            id: team.id,
            text: team.name,
          });
        });
        this.teams = this.teams.slice();
        this.setUsers();
      }
    });
  }
  onSelectTeam(event) {
    this.customReport.selectedTeams = event;
    this.setUsers();
  }

  setUsers() {
    let teamsIds = [];
    if (this.customReport.selectedTeams.indexOf(-1) > -1) {
      this.teams.forEach((team) => {
        if (team.id !== -1) {
          teamsIds.push(team.id);
        }
      });
    } else {
      teamsIds = this.customReport.selectedTeams;
    }
    this.reportsService.findUsersByTeamLeadersIds(teamsIds).subscribe((result) => {
      this.users = [];
      if (result) {
        if (result.length > 0) {
          result.forEach((user) => {
            this.users.push({
              id: user.id,
              text: user.firstName + ' ' + user.lastName,
            });
          });
        }
      }
    });
  }
  onSelectUser(event) {
    this.customReport.usersIds = event;
  }

  setContraventions() {
    this.contraventions = [];
    this.reportsService.getOffences().subscribe((result) => {
      result.forEach((contravention) => {
        this.contraventions.push({
          id: contravention.id,
          text: contravention.id,
        });
      });
      this.contraventions = this.contraventions.slice();
    });
  }
  onSelectContravention(event) {
    this.customReport.selectedContraventions = event;
  }

  setStages() {
    this.reportsService.getStageGroups().subscribe((result) => {
      result.forEach((stage) => {
        this.stages.push({
          id: stage.id,
          text: stage.name,
        });
      });
      this.stages = this.stages.slice();
    });

    // this.stages = [
    //   {
    //     text: 'discount',
    //     id: 'Discount',
    //   },
    //   {
    //     text: 'full charge',
    //     id: 'FullCharge',
    //   },
    //   {
    //     text: 'NTO sent after fixed-to-vehicle / handed-to-driver PCN',
    //     id: 'NTOSent',
    //   },
    //   {
    //     text: 'CC sent',
    //     id: 'CCSent',
    //   },
    //   {
    //     text: 'Order for Recovery sent (not Scotland)',
    //     id: 'OFRSent',
    //   },
    //   {
    //     text: 'bailiffs / sheriff',
    //     id: 'Bailiffs',
    //   }
    // ];
  }
  onSelectStage(event) {
    this.customReport.stages = event;
  }

  setBespoke() {
    this.bespoke = [
      {
        id: 'y',
        text: 'yes',
      },
      {
        id: 'n',
        text: 'no',
      },
    ];
  }
  onSelectBespoke(event) {
    this.customReport.selectedBespoke = event;
  }

  setPcnTypes() {
    this.pcnTypes = [
      {
        id: 1,
        text: 'fixed to car / handed to driver',
      },
      {
        id: 2,
        text: 'CCTV (postal)',
      },
      {
        id: 3,
        text: 'drive-away / prevented-from-issue (postal)',
      }, // ,
      // {
      //   id: 'PcnOnly',
      //   text: 'PCN only (not clamped/removed)',
      // },
      // {
      //   id: 'Clamped',
      //   text: 'clamped',
      // },
      // {
      //   id: 'Removed',
      //   text: 'removed',
      // }
    ];
  }
  onSelectPcnType(event) {
    this.customReport.selectedPcnTypes = event;
  }

  setDecisions() {
    this.decisions = [
      {
        id: '1',
        text: 'uphold PCN',
      },
      {
        id: '2, 4',
        text: 'cancel PCN',
      },
      {
        id: '3',
        text: 'request info',
      },
    ];
  }
  onSelectDecision(event) {
    this.customReport.selectedDecisions = event;
  }

  setPcnPrefixes() {
    this.reportsService.getPcnPrefixes().subscribe((result) => {
      let index = 1;
      result.forEach((code) => {
        this.pcnPrefixes.push({
          id: index++,
          text: code,
        });
      });
      this.pcnPrefixes = this.pcnPrefixes.slice();
    });
  }
  onSelectPcnPrefix(event) {
    this.customReport.selectedPcnPrefixes = event;
  }

  setUfus() {
    this.ufus = [
      {
        id: 'y',
        text: 'yes',
      },
      {
        id: 'n',
        text: 'no',
      },
    ];
  }
  onSelectUfu(event) {
    this.customReport.selectedUfus = event;
  }

  setOverrides() {
    this.overrides = [
      {
        id: 'y',
        text: 'yes',
      },
      {
        id: 'n',
        text: 'no',
      },
    ];
  }
  onSelectOverride(event) {
    this.customReport.selectedOverrides = event;
  }

  setReasons() {
    this.adminService.getAllReasons().subscribe((result) => {
      if (result) {
        result.forEach((reason) => {
          this.reasons.push({
            id: reason.id,
            text: reason.name,
          });
        });
        this.reasons = this.reasons.slice();
      }
    });
  }
  onSelectReason(event) {
    this.customReport.selectedReasons = event;
  }

  setReportsResult(reportsResultUnformatted) {
    this.reportsResult = reportsResultUnformatted;
    // this.setReportsLength();
  }

  // setReportsLength() {
  //  this.reportsRowsLength = 0;
  //  this.reportsRowsLength = this.reportsResult.length;
  // }

  // downloadDocument(format) {
  //  if (this.reportsRowsLength === 0) {
  //    return;
  //  }
  //  if (format === 'excel') {
  //    console.log('Download excel doc');
  //  } else {
  //    console.log('Download pdf doc');
  //  }
  // }

  isSearchEnable() {
    if (this.customReport.selectedTeams.length === 0) {
      return false;
    }
    if (this.customReport.usersIds.length === 0) {
      return false;
    }
    if (this.customReport.selectedContraventions.length === 0) {
      return false;
    }
    if (this.customReport.stages.length === 0) {
      return false;
    }
    if (this.customReport.selectedBespoke.length === 0) {
      return false;
    }
    if (this.customReport.selectedPcnTypes.length === 0) {
      return false;
    }
    if (this.customReport.selectedDecisions.length === 0) {
      return false;
    }
    if (this.customReport.selectedPcnPrefixes.length === 0) {
      return false;
    }
    if (this.customReport.selectedUfus.length === 0) {
      return false;
    }
    if (this.customReport.selectedOverrides.length === 0) {
      return false;
    }
    if (this.customReport.selectedReasons.length === 0) {
      return false;
    }
    if (
      this.customReport.selectedPcnTypes.indexOf(-1) === -1 &&
      this.customReport.selectedPcnTypes.indexOf(1) === -1 &&
      this.customReport.selectedPcnTypes.indexOf(2) === -1 &&
      this.customReport.selectedPcnTypes.indexOf(3) === -1
    ) {
      return false;
    }
    return true;
  }

  searchReports() {
    if (!this.isSearchEnable()) {
      return;
    }
    this.searchingState = true;
    const customReport = this.generateCustomReportModel();
    this.reportsService.getCustomReports(customReport).subscribe(
      (result) => {
        if (result) {
          console.log(result);
          this.setReportsResult(result);
          this.calculateTotalFineAmount();
        }
        this.scrollToResults();
        this.searchingState = false;
      },
      (error) => {
        console.log(error);
        this.searchingState = false;
      }
    );
  }

  scrollToResults() {
    // Ensure change detection runs and updates the view before scrolling
    this.cdr.detectChanges(); // Trigger a change detection cycle
  
    if (this.resultsSection) {
      this.resultsSection.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }  

  showRepLetter(modal, repId) {
    this.modalService.open(modal, { centered: true });

    this.reportsService.getLetterByRepId(repId).subscribe(
      (result) => {
        this.letter = result;
        this.letter.documents = this.removeBr(result.documents);
        this.letter.reasons = this.removeBr(result.reasons);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  removeBr(list) {
    const newList = [];
    list.forEach((item) => {
      const regex = /<br>/gi;
      item = item.replace(regex, '');
      newList.push(item);
    });
    return newList;
  }

  calculateTotalFineAmount() {
    this.totalFineAmount = 0;
    this.reportsResult.forEach((report) => {
      this.totalFineAmount += report.fineNow;
    });
  }

  generateCustomReportModel() {
    const customReport = new CustomReportRequestModel();

    customReport.pcnNumber = this.customReport.pcnNumber;
    customReport.startDate = this.customReport.startDate;
    customReport.endDate = this.customReport.endDate;

    customReport.usersIds = [];
    if (this.customReport.usersIds.indexOf(-1) > -1) {
      this.users.forEach((user) => {
        customReport.usersIds.push(user.id);
      });
    } else {
      customReport.usersIds = this.customReport.usersIds;
    }

    customReport.stages = [];
    if (this.customReport.stages.indexOf(-1) > -1) {
      this.stages.forEach((stage) => {
        customReport.stages.push({
          id: stage.id,
          description: stage.id,
        });
      });
    } else {
      this.stages.forEach((stage) => {
        if (this.customReport.stages.indexOf(stage.id) > -1) {
          customReport.stages.push({
            id: stage.id,
            description: stage.id,
          });
        }
      });
    }

    customReport.offenceTypes = [];
    if (this.customReport.selectedContraventions.indexOf(-1) > -1) {
      this.contraventions.forEach((contravention) => {
        customReport.offenceTypes.push({
          id: contravention.id,
          description: contravention.id,
        });
      });
    } else {
      this.contraventions.forEach((contravention) => {
        if (this.customReport.selectedContraventions.indexOf(contravention.id) > -1) {
          customReport.offenceTypes.push({
            id: contravention.id,
            description: contravention.id,
          });
        }
      });
    }

    customReport.pcnTypes = [];
    if (this.customReport.selectedPcnTypes.indexOf(-1) > -1) {
      this.pcnTypes.forEach((type) => {
        customReport.pcnTypes.push({
          id: type.id,
          description: type.id,
        });
      });
    } else {
      this.pcnTypes.forEach((type) => {
        if (this.customReport.selectedPcnTypes.indexOf(type.id) > -1) {
          customReport.pcnTypes.push({
            id: type.id,
            description: type.id,
          });
        }
      });
    }

    customReport.pcnPrefix = [];
    let pcnPrefixIndex = 1;
    if (this.customReport.selectedPcnPrefixes.indexOf(-1) > -1) {
      this.pcnPrefixes.forEach((prefix) => {
        customReport.pcnPrefix.push({
          id: (pcnPrefixIndex++).toString(),
          description: prefix.text,
        });
      });
    } else {
      this.pcnPrefixes.forEach((prefix) => {
        if (this.customReport.selectedPcnPrefixes.indexOf(prefix.id) > -1) {
          customReport.pcnPrefix.push({
            id: (pcnPrefixIndex++).toString(),
            description: prefix.text,
          });
        }
      });
    }

    customReport.decisions = [];
    let decisionIndex = 1;
    if (this.customReport.selectedDecisions.indexOf(-1) > -1) {
      this.decisions.forEach((decision) => {
        customReport.decisions.push({
          id: (decisionIndex++).toString(),
          description: decision.id,
        });
      });
    } else {
      this.decisions.forEach((decision) => {
        if (this.customReport.selectedDecisions.indexOf(decision.id) > -1) {
          customReport.decisions.push({
            id: (decisionIndex++).toString(),
            description: decision.id,
          });
        }
      });
    }

    customReport.bespoke = [];
    let bespokeIndex = 1;
    if (this.customReport.selectedBespoke.indexOf(-1) > -1) {
      this.bespoke.forEach((bespoke) => {
        customReport.bespoke.push({
          id: bespokeIndex++,
          decision: bespoke.text,
        });
      });
    } else {
      this.bespoke.forEach((bespoke) => {
        if (this.customReport.selectedBespoke.indexOf(bespoke.id) > -1) {
          customReport.bespoke.push({
            id: bespokeIndex++,
            decision: bespoke.text,
          });
        }
      });
    }

    customReport.ufu = [];
    let ufuIndex = 1;
    if (this.customReport.selectedUfus.indexOf(-1) > -1) {
      this.ufus.forEach((ufu) => {
        customReport.ufu.push({
          id: ufuIndex++,
          decision: ufu.id,
        });
      });
    } else {
      this.ufus.forEach((ufu) => {
        if (this.customReport.selectedUfus.indexOf(ufu.id) > -1) {
          customReport.ufu.push({
            id: ufuIndex++,
            decision: ufu.id,
          });
        }
      });
    }

    customReport.reasons = [];
    if (this.customReport.selectedReasons.indexOf(-1) > -1) {
      this.reasons.forEach((reason) => {
        customReport.reasons.push({
          id: reason.id,
          description: reason.id.toString(),
        });
      });
    } else {
      this.reasons.forEach((reason) => {
        if (this.customReport.selectedReasons.indexOf(reason.id) > -1) {
          customReport.reasons.push({
            id: reason.id,
            description: reason.id.toString(),
          });
        }
      });
    }

    customReport.override = [];
    let overrideIndex = 1;
    if (this.customReport.selectedOverrides.indexOf(-1) > -1) {
      this.overrides.forEach((override) => {
        customReport.override.push({
          id: overrideIndex++,
          decision: override.id,
        });
      });
    } else {
      this.overrides.forEach((override) => {
        if (this.customReport.selectedOverrides.indexOf(override.id) > -1) {
          customReport.override.push({
            id: overrideIndex++,
            decision: override.id,
          });
        }
      });
    }

    customReport.location = this.customReport.location;

    return customReport;
  }

  sortReport(filter) {
    this.reportsSort = filter;

    if (filter === 'user') {
      this.sortByFullName();
    } else if (filter === 'date') {
      this.sortByDate();
    } else if (filter === 'pcn') {
      this.sortByPcn();
    } else if (filter === 'stage') {
      this.sortByStage();
    } else if (filter === 'decision') {
      this.sortByDecision();
    } else if (filter === 'charge') {
      this.sortByCharge();
    } else if (filter === 'progression') {
      this.sortByProgression();
    } else if (filter === 'bespoke') {
      this.sortByBespoke();
    } else if (filter === 'override') {
      this.sortByOverride();
    } else if (filter === 'ufu') {
      this.sortByUfu();
    }
  }

  sortByFullName() {
    this.reportsResult = this.reportsResult.sort((a, b) => {
      if (a.fullname < b.fullname) {
        return -1;
      }
      if (a.fullname > b.fullname) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isFullnameAsc) {
      this.reportsResult.reverse();
    }
    this.filterOrder.isFullnameAsc = !this.filterOrder.isFullnameAsc;
  }

  sortByDate() {
    this.reportsResult = this.reportsResult.sort((a, b) => {
      if (a.date < b.date) {
        return -1;
      }
      if (a.date > b.date) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isDateAsc) {
      this.reportsResult.reverse();
    }
    this.filterOrder.isDateAsc = !this.filterOrder.isDateAsc;
  }

  sortByPcn() {
    this.reportsResult = this.reportsResult.sort((a, b) => {
      if (a.pcn < b.pcn) {
        return -1;
      }
      if (a.pcn > b.pcn) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isPcnAsc) {
      this.reportsResult.reverse();
    }
    this.filterOrder.isPcnAsc = !this.filterOrder.isPcnAsc;
  }

  sortByStage() {
    this.reportsResult = this.reportsResult.sort((a, b) => a.stage - b.stage);
    if (!this.filterOrder.isStageAsc) {
      this.reportsResult.reverse();
    }
    this.filterOrder.isStageAsc = !this.filterOrder.isStageAsc;
  }

  sortByDecision() {
    this.reportsResult = this.reportsResult.sort((a, b) => {
      if (a.decision < b.decision) {
        return -1;
      }
      if (a.decision > b.decision) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isDecisionAsc) {
      this.reportsResult.reverse();
    }
    this.filterOrder.isDecisionAsc = !this.filterOrder.isDecisionAsc;
  }

  sortByCharge() {
    this.reportsResult = this.reportsResult.sort((a, b) => a.fineNow - b.fineNow);
    if (!this.filterOrder.isChargeAsc) {
      this.reportsResult.reverse();
    }
    this.filterOrder.isChargeAsc = !this.filterOrder.isChargeAsc;
  }

  sortByProgression() {
    this.reportsResult = this.reportsResult.sort((a, b) => {
      if (a.progression < b.progression) {
        return -1;
      }
      if (a.progression > b.progression) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isProgressionAsc) {
      this.reportsResult.reverse();
    }
    this.filterOrder.isProgressionAsc = !this.filterOrder.isProgressionAsc;
  }

  sortByBespoke() {
    this.reportsResult = this.reportsResult.sort((a, b) => {
      if (a.bespoke < b.bespoke) {
        return -1;
      }
      if (a.bespoke > b.bespoke) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isBespokeAsc) {
      this.reportsResult.reverse();
    }
    this.filterOrder.isBespokeAsc = !this.filterOrder.isBespokeAsc;
  }

  sortByOverride() {
    this.reportsResult = this.reportsResult.sort((a, b) => {
      if (a.override < b.override) {
        return -1;
      }
      if (a.override > b.override) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isOverrideAsc) {
      this.reportsResult.reverse();
    }
    this.filterOrder.isOverrideAsc = !this.filterOrder.isOverrideAsc;
  }

  sortByUfu() {
    this.reportsResult = this.reportsResult.sort((a, b) => {
      if (a.ufu < b.ufu) {
        return -1;
      }
      if (a.ufu > b.ufu) {
        return 1;
      }
      return 0;
    });
    if (!this.filterOrder.isUfuAsc) {
      this.reportsResult.reverse();
    }
    this.filterOrder.isUfuAsc = !this.filterOrder.isUfuAsc;
  }

  showUser(index) {
    return index === 0 ||
      this.reportsResult[index].fullname !== this.reportsResult[index - 1].fullname
      ? this.reportsResult[index].fullname
      : '';
  }
  downloadDocument(format) {
    if (format === 'excel') {
      const extraField =
        '"' +
        this.reportsResult.length +
        ' rows",' +
        '"",' +
        '"",' +
        '"",' +
        '"",' +
        '"£' +
        this.totalFineAmount +
        '",' +
        '"",' +
        '"",' +
        '"",' +
        '"",' +
        '\r\n';
      const dateRangeText = '';
      this.reportsService.exportExcelDocument(
        this.getCustomReportExportJson(),
        this.getCustomReportExportFields(),
        dateRangeText,
        extraField
      );
    } else {
      const reportsTable = document.getElementById('reports-table');
      const reportsTableClass = reportsTable.getAttribute('class');
      this.loadingState = true;
      reportsTable.classList.add('export-design');

      html2canvas(reportsTable, {
        scale: 3, // Increase the scale for better resolution
      }).then(canvas => {
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('landscape', 'pt', 'a4');
        const imgWidth = pdf.internal.pageSize.getWidth();
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        
        pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight, undefined, 'FAST'); // Set quality to 'FAST' for lower compression
        reportsTable.className = reportsTableClass;
        this.loadingState = false;
        pdf.save('reports.pdf');
      });
    }
  }

  getCustomReportExportJson() {
    const dataList = [];
    this.reportsResult.forEach((report) => {
      dataList.push(this.reportsService.exportCustomObject(report));
    });
    return dataList;
  }

  getCustomReportExportFields() {
    return [
      'user',
      'date',
      'PCN',
      'stage',
      'decision',
      'charge',
      'progression',
      'bespoke',
      'override',
      'UFU',
    ];
  }
}
